import React from 'react'
import cx from 'classnames'
import { BtnV2, l } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'

import { BehaviorEditor } from './components/BehaviorEditor'
import { BehaviorLoader } from './components/BehaviorLoader'
import { EmptyState } from './components/EmptyState'
import { useBehavior } from './hooks/useBehavior'

import cm from './styles.module.css'

export const Behavior = ({ title }: { title: string }) => {
  const dispatch = useAppDispatch()

  const {
    showEmptyState,
    showGenerationLoader,
    showEditor,
    isLoading,
    editorRef,
    onSaveEditButtonClick,
  } = useBehavior()

  return (
    <section className={cm.wrapper}>
      <SidebarHeader title={title} />

      <article
        className={cx('p-a', {
          [cm.content_centered]: showEmptyState || showGenerationLoader,
        })}
      >
        {showEmptyState && <EmptyState source="sidebar" />}
        {showGenerationLoader && <BehaviorLoader />}
        {showEditor && (
          <p className="m-b-md font-medium">
            {l.translate('Tell AI how to talk and act when interacting with people')}
          </p>
        )}
        {showEditor && <BehaviorEditor ref={editorRef} />}
      </article>
      <div className="p-a d-flex justify-between">
        <BtnV2
          label={l.translate('Cancel')}
          onClick={() => dispatch(AiAutomationLayoutActions.sidebarClosed())}
        />

        {showEditor && (
          <BtnV2
            loading={isLoading}
            variant="primary"
            label={l.translate('Save and Continue')}
            onClick={onSaveEditButtonClick}
          />
        )}
      </div>
    </section>
  )
}
